export default "__VITE_ASSET__Tq4tghMH__"